import styled from "styled-components";

export const ContainerToPreview = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 310px;
  max-height: 310px;
  min-height: 310px;
`;

export const Container = styled.div`
  padding: 3rem 0;
`;
